module.exports = __webpack_public_path__ + "assets/img/9b4c8f482a81e1fccf4c712a887c8e79.png";